/*
 *   File :  preview.js
 *   Author URI : https://evoqins.com
 *   Description : Shows information about what the user added during KYC.
 *   Integrations : null
 *   Version : v1.1
 */

import { Fragment, useEffect, useState } from "react"
import { useSelector } from "react-redux";
import Icon from "../../../Component/Icon/icon";
import Cookies from 'js-cookie';

import { GradientButton } from "../../../Component/CTA";
import { toast } from "react-toastify";
import APIService from "../../../Service/api-service";
import { FilePreview } from "../../../Component/Form-elements";
import { SignaturePreviewModal } from "../../../Component/Modal";
import { Modal } from "bootstrap";

import { _getKycProfile } from "../../../Helper/api";
import { useNavigate } from "react-router-dom";
import AcceptConsent from "../../../Component/Modal/consent";

const PreviewPage = (props) => {
    const navigate = useNavigate();
    const PREVIEW_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);
    console.log('PREVIEW_DATA', PREVIEW_DATA);
    const reviewIsManual = PREVIEW_DATA?.nri_info?.is_manual ?? PREVIEW_DATA?.is_manual ?? props.is_manual ?? false;

    const [showEdit, setShowEdit] = useState(0);
    console.log('showEdit', showEdit, "props", props);

    const [apiLoader, setApiLoader] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [fileUrl, setFileUrl] = useState("");
    const [showConsent, setShowConsent] = useState(false);
    const [isSelfiPreview, setIsSelfiPreview] = useState(false);

    // useEffect(() => {
    //     const params = new URLSearchParams(window.location.search);
    //     const status = params.get("status"); // success / failure
    //     if (status) {
    //         navigate("/kyc")
    //         _digiLockerCallback();
    //     }
    // }, []);
    useEffect(() => {
        if (showPreview === true) {
            const modal = new Modal(document.getElementById("signature-preview"), {});
            modal.show();
        }
    }, [showPreview])

    useEffect(() => {
        if (showConsent === true) {
            const modal = new Modal(document.getElementById("consent"), {});
            modal.show();
        }
    }, [showConsent])

    const _handleNavigate = () => {

        if (PREVIEW_DATA.onboarding_sub_type === "NRI") {
            switch (showEdit) {
                case 1:
                    props.updateProgress(4, props.text, props.is_manual, true)
                    break;
                case 2:
                    props.updateProgress(2, props.text, props.is_manual, true)
                    break;
                case 3:
                    props.updateProgress(3, props.text, props.is_manual, true)
                    break;
                case 4:
                    props.updateProgress(4, props.text, props.is_manual, true)
                    break;
                case 5:
                    props.updateProgress(5, props.text, props.is_manual, true)
                    break;
                case 6:
                    props.updateProgress(6, props.text, props.is_manual, true)
                    break;
                case 7:
                    props.updateProgress(7, props.text, props.is_manual, true)
                    break;
                case 8:
                    props.updateProgress(8, props.text, true, true)
                    break;
                case 9:
                    props.updateProgress(9, props.text, reviewIsManual, true)
                    break;
                case 10:
                    props.updateProgress(10, props.text, true, true)
                    break;
                default: break;
            }
        } else {
            switch (showEdit) {
                case 1:
                    props.updateProgress(4, props.text, props.is_manual, true)
                    break;
                case 2:
                    props.updateProgress(5, props.text, props.is_manual, true)
                    break;
                case 3:
                    props.updateProgress(6, props.text, props.is_manual, true)
                    break;
                case 4:
                    props.updateProgress(7, props.text, props.is_manual, true)
                    break;
                case 5:
                    props.updateProgress(8, props.text, props.is_manual, true)
                    break;
                case 6:
                    props.updateProgress(3, props.text, props.is_manual, true)
                    break;
                case 7:
                    props.updateProgress(4, props.text, props.is_manual, true)
                    break;
                case 8:
                    props.updateProgress(5, props.text, true, true)
                    break;
                case 9:
                    props.updateProgress(6, props.text, true, true)
                    break;
                case 10:
                    props.updateProgress(2, props.text, true, true)
                    break;
                default: break;

            }
        }
    }

    const _handlePreview = (type) => {
        switch (type) {
            case 1:
                setShowPreview(true);
                setFileUrl(PREVIEW_DATA.additional_info.signature_status)
                break;
            case 2:
                setShowPreview(true);
                setIsSelfiPreview(true);
                setFileUrl(PREVIEW_DATA.selfie_captured)
                break;
        }
    }

    // API - initiate digilocker to complete kyc
    const _handleProceed = () => {
        // if (props.accountType === "NRI" && PREVIEW_DATA?.nri_info.is_manual) {
        //     props.updateProgress(11);
        //     return;
        // }
        setApiLoader(true);
        let url = PREVIEW_DATA?.nri_info.is_manual ? 'kyc/esign/initiate-agreement' : 'kyc/esign/initiate'; //kyc/esign/initiate-agreement - for manual upload
        APIService(false, url, null, "access", false).then((response) => {
            if (response.status_code === 200) {
                _getKycProfile();
                if (PREVIEW_DATA?.nri_info.is_manual === false) {
                    _initiateDigiLocker(response.data.id, response.data.signing_parties[0].identifier, response.data.access_token.id);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
                setApiLoader(false);
            }
        })
    };

    // open digilocker UI to enter aadhar number
    async function _initiateDigiLocker(digiLockerId, mail, token_id = Cookies.get("digio_token")) {
        // var Digio = await window.Digio;
        // var options = {
        //     // "environment" : "production", 
        //     "environment": process.env.REACT_APP_DIGILOCKER_ENVIRONMENT,
        //     "callback": _digiLockerCallback,
        //     "logo": process.env.REACT_APP_LOGO
        // };

        // var digio = new Digio(options);

        // try {
        //     digio.init();  // Call init on user action (eg.button press) and then proceed to asynchronous upload
        //     digio.submit(digiLockerId, mail, token_id);
        // } catch (err) {
        //     // console.log(err)
        //     this.notify("Allow pop-ups and reload the page to fetch from digilocker. ")
        // }
        try {
            // Use sandbox/test URL
            const baseUrl = process.env.REACT_APP_DIGILOCKER_ENVIRONMENT === "production" ? "https://app.digio.in/#/gateway/login" : "https://ext-gateway.digio.in/#/gateway/login"

            const sdkver = "11.0";
            const method = "otp";
            const redirect_timeout = 2800;

            const theme = encodeURIComponent(
                JSON.stringify({
                    PRIMARY_COLOR: "#2979BF",
                    FONT_FAMILY: "",
                    FONT_URL: "",
                    FONT_FORMAT: "",
                })
            )
            let url_digio_callback = `/digio-callback?verification-type=esign`;

            const redirectUrl = encodeURIComponent(
                window.location.origin + url_digio_callback
            );

            const url = `${baseUrl}/${digiLockerId}/${token_id}/${mail}?token_id=${token_id}&sdkver=${sdkver}&method=${method}&redirect_timeout=${redirect_timeout}&theme=${theme}&redirect_url=${redirectUrl}`;

            // Open in a new tab / page
            window.location.href = (url);
        } catch (err) {
            console.error("Unable to open DigiLocker page", err);
        }
    }


    const _nextStep = async () => {
        const kyc_data = await _getKycProfile();
        setApiLoader(false);
        props.updateProgress(props.text === "Minor" ? 6 : 10);
    }

    const LabelAnswer = (props) => {
        return (
            <Fragment>
                <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-16px mb-2">{props.label}</p>
                <p className="color-black e-poppins-medium e-font-sm-16-14 line-height-22px mb-0 word-break-all">{props.answer ? props.answer : "-"}</p>
            </Fragment>
        )
    }

    const HeadingEdit = (props) => {
        return (
            <div className="d-flex align-items-center justify-content-between mb-4">
                <p className="color-jett-black e-poppins-medium e-font-sm-16-14 mb-0">{props.heading}</p>
                <div className="d-flex align-items-center cursor-pointer position-relative"
                    onMouseEnter={() => setShowEdit(props.type)}
                    onMouseLeave={() => setShowEdit(0)}
                    onClick={_handleNavigate}>
                    <span className="color-primary-color e-poppins-medium e-font-sm-16-14 line-height-16px me-1">Edit</span>
                    <Icon icon="Pen-square"
                        size={24} />
                    {
                        showEdit === props.type &&
                        <span className="color-outer-space e-poppins-regular e-font-12-sm-10 line-height-12px bg-white position-absolute px-2 e-preview-edit border-radius-4px">Edit</span>
                    }
                </div>
            </div>
        )
    }
    return (
        <Fragment>
            <div className="mb-sm-0 mb-3">
                <p className="color-black e-poppins e-poppins-bold e-font-24-sm-18 mb-2 mt-2">Review your detail</p>
                <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px mb-0">
                    {
                        PREVIEW_DATA.onboarding_sub_type === "HUF" ?
                            "Review all your given detail and continue"
                            :
                            "Review all your given detail and continue to e-sign process."
                    }
                </p>
                <div className="row margin-32px-top">
                    {
                        PREVIEW_DATA.onboarding_sub_type === "HUF" ?
                            <div className="col-lg-7 col-md-7 col-12">
                                {/* Pan detail */}
                                <div className="border-radius-8px bg-very-light-alice-blue p-3">
                                    <p className="color-jett-black e-poppins-medium e-font-16 mb-4">PAN details</p>
                                    <div className="row">
                                        <div className="col-6">
                                            <LabelAnswer label="PAN number"
                                                answer={PREVIEW_DATA.pan_details.pan} />
                                        </div>
                                        <div className="col-6">
                                            <LabelAnswer label="Date of birth"
                                                answer={PREVIEW_DATA.pan_details.date_of_birth_str} />
                                        </div>
                                        <div className="col-6 pt-3">
                                            <LabelAnswer label="Date of Incorporation"
                                                answer={PREVIEW_DATA.pan_details.date_of_birth_str} />
                                        </div>
                                    </div>
                                </div>

                                <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                    <HeadingEdit heading="First applicant & co-pacarcner details" type={6} />
                                    <div className="row">
                                        <p className="color-outer-space e-poppins-regular e-font-14 line-height-14px margin-12px-bottom mt-2">Personal details</p>
                                        <div className="col-6">
                                            <LabelAnswer label="Karta name"
                                                answer={PREVIEW_DATA.huf_info?.karta_name} />
                                        </div>
                                        <div className="col-6">
                                            <LabelAnswer label="Karta PAN"
                                                answer={PREVIEW_DATA.huf_info?.karta_pan} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Date of birth"
                                                answer={PREVIEW_DATA.huf_info?.karta_dob} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Email"
                                                answer={PREVIEW_DATA.huf_info?.karta_email} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Mobile"
                                                answer={PREVIEW_DATA.huf_info?.karta_mobile} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                            <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                onClick={() => window.open(PREVIEW_DATA?.karta_pan_url)}>View Preview</p>
                                        </div>
                                        <p className="color-jett-black e-poppins-medium e-font-16 margin-12px-bottom mt-4">Address details</p>
                                        <div className="col-6">
                                            <LabelAnswer label="Address"
                                                answer={`${PREVIEW_DATA.huf_info?.karta_address_line_1} ${PREVIEW_DATA.huf_info?.karta_address_line_2 ?? ""} ${PREVIEW_DATA.huf_info?.karta_address_line_3 ?? ""}`} />
                                        </div>
                                        <div className="col-6">
                                            <LabelAnswer label="City"
                                                answer={PREVIEW_DATA.huf_info?.karta_city} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="State"
                                                answer={PREVIEW_DATA.huf_info?.karta_state} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Pincode"
                                                answer={PREVIEW_DATA.huf_info?.karta_pincode} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Address proof"
                                                answer="Electricity bill" />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Proof</p>
                                            <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                onClick={() => window.open(PREVIEW_DATA?.karta_proof_url)}>View Preview</p>
                                        </div>
                                    </div>
                                    <p className="color-jett-black e-poppins-medium e-font-16 margin-12px-bottom mt-3 pt-1">Added coparcener details</p>
                                    {
                                        PREVIEW_DATA.huf_info.coparcener.map((item) => {
                                            return (
                                                <div className="row">
                                                    <p className="color-outer-space e-poppins-regular e-font-14 line-height-14px margin-12px-bottom">Personal details</p>
                                                    <div className="col-6">
                                                        <LabelAnswer label="coparcener name"
                                                            answer={item.coparcener_name} />
                                                    </div>
                                                    <div className="col-6">
                                                        <LabelAnswer label="coparcener PAN"
                                                            answer={item.coparcener_pan} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="Date of birth"
                                                            answer={item.coparcener_dob} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="Email"
                                                            answer={item.coparcener_email} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="Mobile"
                                                            answer={item.coparcener_mobile} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                        <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                            onClick={() => window.open(item.coparcener_pan_url)}>View Preview</p>

                                                    </div>
                                                    <p className="color-jett-black e-poppins-medium e-font-16 margin-12px-bottom mt-4">Address details</p>
                                                    <div className="col-6">
                                                        <LabelAnswer label="Address"
                                                            answer={`${item.coparcener_address_line_1} ${item.coparcener_address_line_2 ?? ""} ${item.coparcener_address_line_3 ?? ""}`} />
                                                    </div>
                                                    <div className="col-6">
                                                        <LabelAnswer label="City"
                                                            answer={item.coparcener_city} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="State"
                                                            answer={item.coparcener_state} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="Pincode"
                                                            answer={item.coparcener_pincode} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="Address proof"
                                                            answer={item.coparcener_proof_type} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Proof</p>
                                                        <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                            onClick={() => window.open(item.coparcener_proof_url)}>View Preview</p>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>


                                {/* Bank details*/}
                                <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                    <HeadingEdit heading="Bank details" type={7} />
                                    <div className="row">
                                        <div className="col-6">
                                            <LabelAnswer label="Bank name"
                                                answer={PREVIEW_DATA.bank_details.bank_name} />
                                        </div>
                                        <div className="col-6">
                                            <LabelAnswer label="Account number"
                                                answer={PREVIEW_DATA.bank_details.masked_account_number} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Account type"
                                                answer={PREVIEW_DATA.bank_details.account_type_text} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="IFSC code"
                                                answer={PREVIEW_DATA.bank_details.ifsc_code} />
                                        </div>
                                    </div>

                                </div>

                                {/* Declaration */}
                                <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                    <HeadingEdit heading="Declarations" type={8} />
                                    <div className="row">
                                        <div className="col-6">
                                            <LabelAnswer label="Tax payee in India"
                                                answer={PREVIEW_DATA.declaration.tax_payer_in_india === true ? "Yes" : "No"} />
                                        </div>
                                        <div className="col-6">
                                            <LabelAnswer label="Politically exposed"
                                                answer={!PREVIEW_DATA.declaration.politically_exposed === true ? "Yes" : "No"} />
                                        </div>
                                        <div className="col-6 mt-3">
                                            <LabelAnswer label="Terms & conditions"
                                                answer={PREVIEW_DATA.declaration.terms_and_condition === true ? "Checked" : "Un Checked"} />
                                        </div>
                                    </div>

                                </div>

                                <div className="margin-56px-top text-center">
                                    <GradientButton label="Submit"
                                        className="px-3 padding-12px-tb e-font-16 "
                                        handleClick={() => props.updateProgress(9, props.text, props.is_manual)} />
                                </div>

                            </div>
                            :
                            PREVIEW_DATA.onboarding_sub_type === "Minor" ?
                                <div className="col-lg-7 col-md-7 col-12">

                                    {/* Pan detail */}
                                    <div className="border-radius-8px bg-very-light-alice-blue p-3">
                                        <p className="color-jett-black e-poppins-medium e-font-16 mb-4">Minor details</p>
                                        <div className="row">
                                            <div className="col-6">
                                                <LabelAnswer label="Name"
                                                    answer={PREVIEW_DATA.minor_details.name_on_pan} />
                                            </div>
                                            <div className="col-6">
                                                <LabelAnswer label="Date of birth"
                                                    answer={PREVIEW_DATA.minor_details.date_of_birth} />
                                            </div>
                                            <div className="col-6 pt-4">
                                                <LabelAnswer label="Gender"
                                                    answer={PREVIEW_DATA.minor_details.gender_text} />
                                            </div>
                                            <div className="col-6 pt-4">
                                                <LabelAnswer label="PAN"
                                                    answer={PREVIEW_DATA.minor_details.minor_pan} />
                                            </div>
                                            <div className="col-6 pt-4">
                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                    onClick={() => window.open(PREVIEW_DATA.minor_details.minor_pan_proof)}>View Preview</p>
                                            </div>
                                            <div className="col-6 pt-4">
                                                <LabelAnswer label="ID Name"
                                                    answer={PREVIEW_DATA.minor_details.minor_dob_proof_text} />
                                            </div>
                                            <div className="col-6 pt-4">
                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">ID proof</p>
                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                    onClick={() => window.open(PREVIEW_DATA.minor_details.minor_dob_proof)} >View Preview</p>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Guardian detail */}
                                    <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                        <HeadingEdit heading="Guardian Details" type={10} />
                                        <div className="row">
                                            <div className="col-6">
                                                <LabelAnswer label="Name"
                                                    answer={PREVIEW_DATA.guardian_details.guardian_name} />
                                            </div>
                                            <div className="col-6">
                                                <LabelAnswer label="Relation"
                                                    answer={PREVIEW_DATA.guardian_details.guardian_relation_text} />
                                            </div>
                                            <div className="col-6 pt-3">
                                                <LabelAnswer label="PAN number"
                                                    answer={PREVIEW_DATA.guardian_details.guardian_pan} />
                                            </div>

                                            <div className="col-6 pt-3">
                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                    onClick={() => window.open(PREVIEW_DATA.guardian_details.guardian_pan_proof)}>View Preview</p>
                                            </div>
                                            <div className="col-6 pt-3">
                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Signature</p>
                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                    onClick={() => window.open(PREVIEW_DATA.guardian_details.guardian_signature)}>View Preview</p>
                                            </div>
                                            <div className="col-6 pt-3">
                                                <LabelAnswer label="ID Name"
                                                    answer={PREVIEW_DATA.guardian_details.guardian_address_proof_text} />
                                            </div>
                                            <div className="col-6 pt-3">
                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">ID proof</p>
                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                    onClick={() => window.open(PREVIEW_DATA.guardian_details.guardian_address_proof)}>View Preview</p>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Guardian detail */}
                                    <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                        <HeadingEdit heading="Current Address" type={10} />
                                        <div className="row mb-4">
                                            <div className="col-6">
                                                <LabelAnswer label="Address"
                                                    answer={`${PREVIEW_DATA.address.current_address_line_1} ${PREVIEW_DATA.address.current_address_line_2} ${PREVIEW_DATA.address.current_address_line_3}`} />
                                            </div>
                                            <div className="col-6">
                                                <LabelAnswer label="Country"
                                                    answer={PREVIEW_DATA.address.current_address_country_name} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <LabelAnswer label="State"
                                                    answer={PREVIEW_DATA.address.current_address_state_name} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <LabelAnswer label="City"
                                                    answer={PREVIEW_DATA.address.current_address_city_name} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <LabelAnswer label="Pincode"
                                                    answer={PREVIEW_DATA.address.current_address_pincode} />
                                            </div>


                                        </div>
                                        {PREVIEW_DATA.address.same_as_correspondence === false && <Fragment>
                                            <p className="color-eerie-black e-poppins-semi-bold e-font-16 line-height-16px mb-3">Permanent Address</p>
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Address"
                                                        answer={`${PREVIEW_DATA.address.permanent_address_line_1} ${PREVIEW_DATA.address.permanent_address_line_2}`} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Country"
                                                        answer={PREVIEW_DATA.address.permanent_address_country_name} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="State"
                                                        answer={PREVIEW_DATA.address.permanent_address_state_name} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="City"
                                                        answer={PREVIEW_DATA.address.permanent_address_city_name} />
                                                </div>

                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Pincode"
                                                        answer={PREVIEW_DATA.address.permanent_address_pincode} />
                                                </div>


                                            </div>
                                        </Fragment>
                                        }
                                    </div>

                                    {/* Declaration */}
                                    <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                        <HeadingEdit heading="Declarations" type={6} />
                                        <div className="row">
                                            <div className="col-6">
                                                <LabelAnswer label="Tax payee in India"
                                                    answer={PREVIEW_DATA.declaration.tax_payer_in_india === true ? "Yes" : "No"} />
                                            </div>
                                            <div className="col-6">
                                                <LabelAnswer label="Politically exposed"
                                                    answer={!PREVIEW_DATA.declaration.politically_exposed === true ? "Yes" : "No"} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <LabelAnswer label="Terms & conditions"
                                                    answer={PREVIEW_DATA.declaration.terms_and_condition === true ? "Checked" : "Un Checked"} />
                                            </div>
                                        </div>

                                    </div>


                                    {/* Bank details*/}
                                    <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                        <HeadingEdit heading="Bank details" type={7} />
                                        <div className="row">
                                            <div className="col-6">
                                                <LabelAnswer label="Bank name"
                                                    answer={PREVIEW_DATA.bank_details.bank_name} />
                                            </div>
                                            <div className="col-6">
                                                <LabelAnswer label="Account number"
                                                    answer={PREVIEW_DATA.bank_details.masked_account_number} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <LabelAnswer label="Account type"
                                                    answer={PREVIEW_DATA.bank_details.account_type_text} />
                                            </div>
                                            <div className="col-6 mt-3">
                                                <LabelAnswer label="IFSC code"
                                                    answer={PREVIEW_DATA.bank_details.ifsc_code} />
                                            </div>
                                        </div>

                                    </div>

                                    {PREVIEW_DATA.bse_form_url && <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                        <div className="col-6">
                                            <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">BSE Form</p>
                                            <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                onClick={() => window.open(PREVIEW_DATA.bse_form_url)}>View Preview</p>
                                        </div>
                                    </div>}

                                    <div className="margin-56px-top-sm-16 text-center">
                                        <GradientButton label="Save & proceed to e-sign"
                                            loading={apiLoader}
                                            className="px-3 padding-12px-tb e-font-16 mob-w-100"
                                            handleClick={() => setShowConsent(true)} />
                                    </div>



                                </div>
                                :
                                PREVIEW_DATA.onboarding_sub_type === "NRI" ?
                                    <div className="col-lg-7 col-md-7 col-12">

                                        {/* Pan detail */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3">
                                            <p className="color-jett-black e-poppins-medium e-font-16 mb-4">PAN details</p>
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Name"
                                                        answer={PREVIEW_DATA.pan_details.name_on_pan} />
                                                </div>
                                                <div className="col-6 ">
                                                    <LabelAnswer label="PAN"
                                                        answer={PREVIEW_DATA.pan_details.pan} />
                                                </div>
                                                <div className="col-6 pt-3">
                                                    <LabelAnswer label="Date of birth"
                                                        answer={PREVIEW_DATA.pan_details.date_of_birth_str} />
                                                </div>

                                            </div>

                                        </div>

                                        {/* Contact Details */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            {/* <HeadingEdit heading="Contact Details" type={2} /> */}
                                            <p className="color-jett-black e-poppins-medium e-font-16 mb-4">Contact Details</p>
                                            <div className="row">
                                                <div className="col-6">
                                                    <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-16px mb-2">Foreign Mobile Number</p>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <p className="color-black e-poppins-medium e-font-sm-16-14 line-height-22px mb-0">{PREVIEW_DATA.nri_info.foreign_country_code}</p>
                                                        <p className=" color-black e-poppins-medium e-font-sm-16-14 line-height-22px mb-0 word-break-all">{PREVIEW_DATA.nri_info.foreign_number}</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/* Guardian detail */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <HeadingEdit heading="Personal information" type={4} />
                                            <div className="row mb-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Gender"
                                                        answer={`${PREVIEW_DATA.additional_info.gender_text}`} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Marital status"
                                                        answer={PREVIEW_DATA.additional_info.marital_status_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Occupation"
                                                        answer={PREVIEW_DATA.additional_info.occupation_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Annual income"
                                                        answer={PREVIEW_DATA.additional_info.income_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Digital signature"
                                                        answer={PREVIEW_DATA.additional_info.signature_status.trim().length !== 0 ? 'Added' : 'Not Added'} />
                                                </div>

                                            </div>
                                            {/* {PREVIEW_DATA.address.same_as_correspondence === false && <Fragment>
                                                <p className="color-eerie-black e-poppins-semi-bold e-font-16 line-height-16px mb-3">Permanent Address</p>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <LabelAnswer label="Address"
                                                            answer={`${PREVIEW_DATA.address.permanent_address_line_1} ${PREVIEW_DATA.address.permanent_address_line_2}`} />
                                                    </div>
                                                    <div className="col-6">
                                                        <LabelAnswer label="Country"
                                                            answer={PREVIEW_DATA.address.permanent_address_country_name} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="State"
                                                            answer={PREVIEW_DATA.address.permanent_address_state_name} />
                                                    </div>
                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="City"
                                                            answer={PREVIEW_DATA.address.permanent_address_city_name} />
                                                    </div>

                                                    <div className="col-6 mt-3">
                                                        <LabelAnswer label="Pincode"
                                                            answer={PREVIEW_DATA.address.permanent_address_pincode} />
                                                    </div>


                                                </div>
                                            </Fragment>
                                            } */}
                                        </div>

                                        {/* Declaration */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <HeadingEdit heading="Declarations" type={6} />
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Tax payee in India"
                                                        answer={PREVIEW_DATA.declaration.tax_payer_in_india === true ? "Yes" : "No"} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Politically exposed"
                                                        answer={PREVIEW_DATA.declaration.politically_exposed === true ? "Yes" : "No"} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Terms & conditions"
                                                        answer={PREVIEW_DATA.declaration.terms_and_condition === true ? "Checked" : "Un Checked"} />
                                                </div>
                                            </div>

                                        </div>





                                        {/* Address details */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">


                                            <HeadingEdit heading="Address details" type={5} />
                                            <div className="row">
                                                <p className="color-black e-poppins-regular e-font-14  mb-2">Overseas address</p>

                                                <div className="col-6">
                                                    <LabelAnswer label="Address line 1"
                                                        answer={PREVIEW_DATA.nri_info.overseas_address.line1} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Address line 2"
                                                        answer={PREVIEW_DATA.nri_info.overseas_address.line1} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="City"
                                                        answer={PREVIEW_DATA.nri_info.overseas_address.city_name} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Postal code"
                                                        answer={PREVIEW_DATA.nri_info.overseas_address.pincode} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Country"
                                                        answer={PREVIEW_DATA.nri_info.overseas_address.country_name} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Address proof"
                                                        answer={PREVIEW_DATA.nri_info.overseas_address.proof_type} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">ID Proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(PREVIEW_DATA.nri_info.overseas_address.proof_url)}>View Preview</p>
                                                </div>
                                            </div>


                                            <div className="row padding-22px-top">
                                                <p className="color-black e-poppins-regular e-font-14  mb-2">Local address</p>

                                                <div className="col-6">
                                                    <LabelAnswer label="Address line 1"
                                                        answer={PREVIEW_DATA.nri_info.local_address.line1} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Address line 2"
                                                        answer={PREVIEW_DATA.nri_info.local_address.line1} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="City"
                                                        answer={PREVIEW_DATA.nri_info.local_address.city_name} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Postal code"
                                                        answer={PREVIEW_DATA.nri_info.local_address.pincode} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Country"
                                                        answer={PREVIEW_DATA.nri_info.local_address.country_name} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Address proof"
                                                        answer={PREVIEW_DATA.nri_info.local_address.proof_type} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">ID Proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(PREVIEW_DATA.nri_info.local_address.proof_url)}>View Preview</p>
                                                </div>
                                            </div>

                                        </div>


                                        {/* FATCA information */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <HeadingEdit heading="FATCA information" type={6} />

                                            {PREVIEW_DATA.nri_info.tax_residencies.length !== 0 ? (
                                                PREVIEW_DATA.nri_info.tax_residencies.map((tax_details, key) => (
                                                    <div key={key} className="fatca-country-block mb-3 ps-0 p-3 border-radius-8px">
                                                        <h6 className="fw-semibold mb-3">
                                                            {`Tax Residency ${key + 1} – `}
                                                            <span className="text-primary">{tax_details.tax_country}</span>
                                                        </h6>

                                                        <div className="row">
                                                            <div className="col-6">
                                                                <LabelAnswer
                                                                    label="TIN number"
                                                                    answer={tax_details.tax_number ? tax_details.tax_number : "-"}
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                <LabelAnswer
                                                                    label="Country of tax residence"
                                                                    answer={tax_details.tax_country}
                                                                />
                                                            </div>

                                                            {tax_details.has_tin === false && (
                                                                <div className="col-12 mt-3">
                                                                    <LabelAnswer
                                                                        label="Remarks"
                                                                        answer={
                                                                            tax_details.tin_unavailable_reason_text
                                                                                ? tax_details.tin_unavailable_reason_text
                                                                                : "-"
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="row">
                                                    <div className="col-6">
                                                        <LabelAnswer
                                                            label="Politically Exposed"
                                                            answer={
                                                                PREVIEW_DATA.nri_info.politically_exposed === true ? "true" : "false"
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <LabelAnswer
                                                            label="Country"
                                                            answer={
                                                                PREVIEW_DATA.nri_info.tax_payer_other_country === false
                                                                    ? "India"
                                                                    : null
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>



                                        {/* Bank details*/}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <HeadingEdit heading="Bank details" type={7} />
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Bank name"
                                                        answer={PREVIEW_DATA.bank_details.bank_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Account number"
                                                        answer={PREVIEW_DATA.bank_details.masked_account_number} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Account type"
                                                        answer={PREVIEW_DATA.bank_details.account_type_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="IFSC code"
                                                        answer={PREVIEW_DATA.bank_details.ifsc_code} />
                                                </div>
                                                {/* <div className="col-6 mt-3">
                                                    <LabelAnswer label="Bank proof"
                                                        answer={PREVIEW_DATA.bank_details.bank_proof} />
                                                </div> */}

                                                <div className="col-6 pt-4">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Bank proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(PREVIEW_DATA.bank_details.bank_statement_url)}>View Preview</p>
                                                </div>
                                            </div>

                                        </div>

                                        {/* Nominee details*/}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <HeadingEdit heading="Nominee details" type={8} />

                                            {PREVIEW_DATA.nominees.length !== 0 ?

                                                PREVIEW_DATA.nominees.map((nominee, key) => (

                                                    <div className="row pt-4">

                                                        <p className="color-black e-poppins-medium e-font-sm-16-14 line-height-22px  word-break-all">{`Nominee ${key + 1}`}</p>

                                                        <div className="col-6">
                                                            <LabelAnswer label="Nominee name"
                                                                answer={nominee.name} />
                                                        </div>
                                                        <div className="col-6">
                                                            <LabelAnswer label="Date of Birth"
                                                                answer={nominee.date_of_birth_str} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Relation"
                                                                answer={nominee.relationship} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Allocation percentage "
                                                                answer={nominee.allocation_text} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Identity document number"
                                                                answer={nominee.nominee_mobile} />
                                                        </div>

                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Identity document"
                                                                answer={nominee.nominee_proof_id} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Mobile"
                                                                answer={nominee.nominee_mobile} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Email"
                                                                answer={nominee.nominee_email} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Address"
                                                                answer={nominee.nominee_address_line1} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Pincode"
                                                                answer={nominee.nominee_pincode} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="State"
                                                                answer={nominee.nominee_state} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="City"
                                                                answer={nominee.nominee_city} />
                                                        </div>
                                                        <div className="col-6 mt-3">
                                                            <LabelAnswer label="Country"
                                                                answer={nominee.nominee_country} />
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <p className="color-black e-poppins-regular e-font-sm-16-14 line-height-22px  word-break-all">Nominee Opted Out</p>
                                            }

                                        </div>


                                        {/* Uploaded forms*/}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <HeadingEdit heading={PREVIEW_DATA.selfie_captured ? "Selfie capture" : "Uploaded forms"} type={9} />

                                            <div className="row">
                                                {PREVIEW_DATA.selfie_captured ? (
                                                    <div className="col-6">
                                                        <LabelAnswer
                                                            label="Status"
                                                            answer="Done"
                                                        />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="col-6">
                                                            <LabelAnswer
                                                                label="Account opening form"
                                                                answer={PREVIEW_DATA.bse_form_url ? "Added" : "Not Added"}
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <LabelAnswer
                                                                label="FATCA / Ultimate Beneficial Ownership"
                                                                answer={PREVIEW_DATA.ubo_form_url ? "Added" : "Not Added"}
                                                            />
                                                        </div>
                                                        {/* <div className="col-6 mt-3">
                                                            <LabelAnswer
                                                                label="Ultimate Beneficial Ownership"
                                                                answer={PREVIEW_DATA.ubo_form_url ? "Added" : "Not Added"}
                                                            />
                                                        </div> */}
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        <div className="margin-56px-top-sm-16 text-center">
                                            <GradientButton label="Save & proceed to e-sign"
                                                loading={apiLoader}
                                                className="px-3 padding-12px-tb e-font-16 mob-w-100"
                                                handleClick={() => setShowConsent(true)} />
                                        </div>



                                    </div>
                                    :
                                    <div className="col-lg-7 col-md-7 col-12">

                                        {/* Pan detail */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3">
                                            <p className="color-jett-black e-poppins-medium e-font-sm-16-14 mb-4">PAN details</p>
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="PAN number"
                                                        answer={PREVIEW_DATA.pan_details.pan} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Date of birth"
                                                        answer={PREVIEW_DATA.pan_details.date_of_birth_str} />
                                                </div>
                                            </div>

                                        </div>

                                        {/* KRA information */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-sm-3 mt-2">
                                            <p className="color-jett-black e-poppins-medium e-font-sm-16-14 mb-4">KRA information</p>
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Name as on PAN"
                                                        answer={PREVIEW_DATA.kra_info.name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Nationality"
                                                        answer={PREVIEW_DATA.kra_info.nationality === true ? "Indian" : null} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Aadhar number"
                                                        answer={PREVIEW_DATA.kra_info.aadhaar} />
                                                </div>
                                                <div className="col-12 mt-3">
                                                    <LabelAnswer label="Address"
                                                        answer={PREVIEW_DATA.kra_info.address} />
                                                </div>
                                            </div>

                                        </div>

                                        {/* Additional information */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-sm-3 mt-2">
                                            <HeadingEdit heading="Additional information" type={1} />
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Fathers name"
                                                        answer={PREVIEW_DATA.additional_info.father_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Gender"
                                                        answer={PREVIEW_DATA.additional_info.gender_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Marital status"
                                                        answer={PREVIEW_DATA.additional_info.marital_status_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Occupation"
                                                        answer={PREVIEW_DATA.additional_info.occupation_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Annual income"
                                                        answer={PREVIEW_DATA.additional_info.income_text} />
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-12 mt-3">
                                                    <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-16px mb-2">Signature status</p>
                                                    {
                                                        PREVIEW_DATA.additional_info.signature_status &&
                                                        <FilePreview fileName={
                                                            PREVIEW_DATA.additional_info.signature_status.substring(PREVIEW_DATA.additional_info.signature_status.lastIndexOf('/') + 1, PREVIEW_DATA.additional_info.signature_status.indexOf('?'))}
                                                            fileUrl={PREVIEW_DATA.additional_info.signature_status}
                                                            fileSize={PREVIEW_DATA.additional_info.file_size}
                                                            showBinIcon={false}
                                                            preview={true}
                                                            previewFile={() => _handlePreview(1)} />
                                                    }

                                                </div>
                                            </div>

                                        </div>

                                        {/* Declaration */}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-sm-3 mt-2">
                                            <HeadingEdit heading="Declarations" type={2} />
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Tax payee in India"
                                                        answer={PREVIEW_DATA.declaration.tax_payer_in_india === true ? "Yes" : "No"} />
                                                </div>

                                                <div className="col-6">
                                                    <LabelAnswer label="Politically exposed"
                                                        answer={!PREVIEW_DATA.declaration.politically_exposed === true ? "Yes" : "No"} /> {/* negation needed since backed team is already performing it  */}
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Terms & conditions"
                                                        answer={PREVIEW_DATA.declaration.terms_and_condition === true ? "Checked" : "Unchecked"} />
                                                </div>
                                            </div>

                                        </div>

                                        {/* Bank details*/}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-sm-3 mt-2">
                                            <HeadingEdit heading="Bank details" type={3} />
                                            <div className="row">
                                                <div className="col-6">
                                                    <LabelAnswer label="Bank name"
                                                        answer={PREVIEW_DATA.bank_details.bank_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Account number"
                                                        answer={PREVIEW_DATA.bank_details.account_number} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Account type"
                                                        answer={PREVIEW_DATA.bank_details.account_type_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="IFSC code"
                                                        answer={PREVIEW_DATA.bank_details.ifsc_code} />
                                                </div>
                                            </div>

                                        </div>

                                        {/* Nominee*/}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-sm-3 mt-2">
                                            <HeadingEdit heading="Nominee"
                                                type={4} />

                                            {
                                                PREVIEW_DATA.skip_nominee ?
                                                    <LabelAnswer label="Status"
                                                        answer={'Opt Out'} />
                                                    :
                                                    PREVIEW_DATA.nominees.map((item, key) =>
                                                        <div className="row mt-3" key={key}>
                                                            <div className="col-6">
                                                                <LabelAnswer label="Nominee name"
                                                                    answer={item.name} />
                                                            </div>
                                                            <div className="col-6">
                                                                <LabelAnswer label="Relation"
                                                                    answer={item.relationship} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="Allocation percentage"
                                                                    answer={item.allocation_text} />
                                                            </div>
                                                            {
                                                                item.guardian_name !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label="Guardian name"
                                                                        answer={item.guardian_name} />
                                                                </div>
                                                            }
                                                            {
                                                                item.guardian_relationship.length !== 0 &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label="Guardian relation"
                                                                        answer={item.guardian_relationship} />
                                                                </div>
                                                            }
                                                            {
                                                                item.guardian_pan !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label="Guardian PAN"
                                                                        answer={item.guardian_pan} />
                                                                </div>
                                                            }
                                                            {
                                                                item.nominee_email !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label="Email"
                                                                        answer={item.nominee_email} />
                                                                </div>
                                                            }
                                                            {
                                                                item.nominee_mobile !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label="Mobile"
                                                                        answer={item.nominee_mobile} />
                                                                </div>
                                                            }
                                                            {
                                                                item.nominee_proof_id !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label={`${item.nominee_proof_type} proof number`}
                                                                        answer={item.nominee_proof_id} />
                                                                </div>
                                                            }

                                                            {
                                                                item.nominee_email_declaration !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label={`Email declaration`}
                                                                        answer={item.nominee_email_declaration} />
                                                                </div>
                                                            }
                                                            {
                                                                item.nominee_mobile_declaration !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label={`Mobile declaration`}
                                                                        answer={item.nominee_mobile_declaration} />
                                                                </div>
                                                            }
                                                            {
                                                                item.nominee_address_line3 !== null &&
                                                                <div className="col-6 mt-3">
                                                                    <LabelAnswer label={`Address`}
                                                                        answer={`${item.nominee_address_line1 ?? ""} ${item.nominee_address_line2 ?? ""} ${item.nominee_address_line3 ?? ""} ${item.nominee_city ?? ""} ${item.nominee_state ?? ""}, ${item.nominee_pincode ?? ""} ${item.nominee_country ?? ""}`} />
                                                                </div>
                                                            }
                                                        </div>
                                                    )
                                            }

                                        </div>

                                        {/* In person verification*/}
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-sm-3 mt-2">
                                            <HeadingEdit heading="In person verification" type={5} />
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-12">
                                                    <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-16px mb-2">Status</p>
                                                    {
                                                        PREVIEW_DATA.selfie_captured &&
                                                        <FilePreview fileName={PREVIEW_DATA.selfie_captured.substring(PREVIEW_DATA.selfie_captured.lastIndexOf('/') + 1, PREVIEW_DATA.selfie_captured.indexOf('?'))}
                                                            fileUrl={PREVIEW_DATA.selfie_captured}
                                                            fileSize={PREVIEW_DATA.selfie_file_size}
                                                            showBinIcon={false}
                                                            preview={true}
                                                            location={PREVIEW_DATA.selfie_captured_object?.address}
                                                            previewFile={() => _handlePreview(2)} />
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                        <div className="border-radius-8px bg-very-light-alice-blue p-3 mt-3">
                                            <div className="col-6">
                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">XML Aadhaar</p>
                                                {
                                                    PREVIEW_DATA.xml_aadhaar ?
                                                        <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                            onClick={() => window.open(PREVIEW_DATA.xml_aadhaar)}>Download</p>
                                                        :
                                                        <p className="color-black e-poppins-medium e-font-sm-16-14 line-height-22px mb-0 word-break-all">-</p>
                                                }
                                            </div>
                                        </div>

                                        <div className="margin-56px-top-sm-16 text-center">
                                            <GradientButton label="Save & proceed to e-sign"
                                                loading={apiLoader}
                                                className="px-3 padding-12px-tb e-font-16 mob-w-100"
                                                handleClick={() => setShowConsent(true)} />
                                        </div>
                                    </div>
                    }
                </div>
            </div>
            {
                showPreview === true &&
                <SignaturePreviewModal file={fileUrl}
                    location={PREVIEW_DATA?.selfie_captured_object?.address}
                    showLocation={isSelfiPreview}
                    close={() => { setShowPreview(false); setIsSelfiPreview(false) }} />
            }
            {
                showConsent === true &&
                <AcceptConsent accept={_handleProceed}
                    close={() => setShowConsent(false)} />
            }
        </Fragment>
    )
}

export default PreviewPage
